import logo from './logo.svg';
import './App.css';


import flagimage from './ui/img/flag.gif'

import './ui/css/global.css';
import './ui/bootstrap/bootstrap.min.css';
import './ui/css/styles.css';
import './ui/css/core.css';
import './ui/css/play.css';

import GameGL from './ui/gameGL.tsx';
import { useEffect, useState } from 'react';
import { get_config_mx, initsolana } from './lib/actionsSol.ts';
import { get_config_wax, initanchor, initwax } from './lib/actionsWax.js';
import { ANCHOR, BC_SOLANA } from './lib/blockchainSession.ts';

const host = 'https://www.crazy-cars.io';
//const host = 'http://localhost:3000';

function App() {

  const [blockchaininfos, setblockchaininfos] = useState(null)
  const [gameConfig, setgameConfig] = useState(null)
  const [tracks, settracks] = useState(null)


  useEffect(()=>{

    fetch(host + '/api/getinfos', { credentials: "include"}).then((data) => {

      data.json().then((res) => {

        const infos = res.result;
        fetch(infos.baseAddr+'/api/gettracks', { credentials: "include"}).then((tdata) => {

          tdata.json().then((tt) => settracks(tt.result));

          if(infos.bc_type == BC_SOLANA){
            initsolana(infos.endpoints[0]);
            get_config_mx(infos.mainContract, infos.GameKey, infos.cfg_seed).then((gc) =>{setgameConfig(gc); setblockchaininfos(infos); });

          }else{
            initwax(infos.endpoints[0], infos.AA.contract);
            if(infos.logType == ANCHOR)
                initanchor(infos.endpoints[0], infos.chainId);

            get_config_wax(infos.mainContract).then((gc)=>{setgameConfig(gc); setblockchaininfos(infos);})
          }
        });
      })
    });
  }, []);

  if(blockchaininfos === null)
    return <div>loading</div>

  if(gameConfig === null)
    return <div>loading</div>

  if(tracks === null)
    return <div>loading</div>
  
 
  return (
    <div className="App">
      <GameGL blockchaininfos={blockchaininfos} gameConfig={gameConfig} tracks = {tracks}  />
    </div>
  );
}

export default App;
